'use client';

import { ReactNode, createContext, useContext, useState } from 'react';

interface VenuesPageContextType {
  placePrefix: string | null;
  setPlacePrefix: (prefix: string) => void;
}

const VenuesPageContext = createContext<VenuesPageContextType | undefined>(undefined);

export function VenuesPageProvider({
  children,
  initialPlacePrefix = '',
}: {
  children: ReactNode;
  initialPlacePrefix?: string;
}) {
  const [placePrefix, setPlacePrefix] = useState<string>(initialPlacePrefix);

  return <VenuesPageContext.Provider value={{ placePrefix, setPlacePrefix }}>{children}</VenuesPageContext.Provider>;
}

export function usePlacePrefix() {
  const context = useContext(VenuesPageContext);
  if (context === undefined) {
    throw new Error('useVenuesPageContext must be used within a VenuesPageProvider');
  }
  return context.placePrefix;
}
